import * as React from 'react';
import { ITableStore } from '../Table';

export interface ITableRowCellProps {
    /** className to append */
    className?: string;
    /**
     * Internal tableStore data, applied automatically by parent.
     * @ignore
     */
    tableStore?: ITableStore;
    /**
     * Desired width of the column. Received automatically from TableHeadCell.
     * @ignore
     */
    width?: number;
    /**
     * Desired min-width of the column. Received automatically from TableHeadCell.
     * @ignore
     */
    minWidth?: number;
    /**
     * Desired max-width of the column. Received automatically from TableHeadCell.
     * @ignore
     */
    maxWidth?: number;
}

interface IState {

}

/**
 * Use this within TableRow component to render table cell.
 */
export default class TableRowCell extends React.Component<ITableRowCellProps, IState> {
    static displayName: string = 'TableRowCell';

    public render () {
        return (
            <div
                className="table-row-cell-container"
                style={{
                    width: this.props.width,
                    minWidth: this.props.minWidth,
                    maxWidth: this.props.maxWidth,
                }}
            >
                {this.props.children}
            </div>
        );
    }
}
